import React, { useEffect } from 'react';
import './styles.css';
import P from 'prop-types';
import { toast } from 'react-toastify';
import { trackGAEvent, trackMetaPixelEvent } from '../../utils/tracking';

export const SacolaMenuEdicao = ({ param }) => {
  const editar = () => {
    param.onEdit();
  };

  const trackRemoveFromCart = () => {
    trackMetaPixelEvent('RemoveFromCart', {
      content_name: param?.item?.descricao,
      content_ids: [param?.item?.codigo?.toString() || param?.item?.codigo_produto?.toString()],
      content_type: 'product',
      value: parseFloat(param?.item?.total || param?.item?.preco_app || 0),
      currency: 'BRL',
      quantity: param?.item?.quantidade || 1,
    });

    trackGAEvent(
      'Ecommerce',
      'RemoveFromCart',
      param?.item?.descricao,
      parseFloat(param?.item?.total || param?.item?.preco_app || 0),
    );
  };

  const excluir = () => {
    trackRemoveFromCart();

    param.onDelete(param.item);
    toast.error('Item removido da sacola');
  };

  useEffect(() => {
    document.getElementById('top').style.zIndex = '90';
    document.getElementById('categorias').style.zIndex = '90';
    return () => {
      document.getElementById('top').style.zIndex = '999';
      document.getElementById('categorias').style.zIndex = '999';
    };
  }, []);

  return (
    <div>
      {param.item.tipo_produto != 'PIZZA' && (
        <div className="sacola-menu-opcoes" onClick={() => editar()}>
          Editar
        </div>
      )}
      <div className="sacola-menu-opcoes" onClick={() => excluir()}>
        Excluir
      </div>
    </div>
  );
};

SacolaMenuEdicao.propTypes = {
  param: P.object,
};
